<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import { mapState } from "vuex";
import tiengViet from "@/locales/vi-VN";
import english from "@/locales/en-US";

const locales = {
  "vi-VN": tiengViet,
  "en-US": english,
};

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: "vi-VN",
  fallbackLocale: "vi-VN",
  messages: {
    "vi-VN": locales["vi-VN"].messages,
    "en-US": locales["en-US"].messages,
  },
  dateTimeFormats: {
    "vi-VN": locales["vi-VN"].dateTimeFormats,
    "en-US": locales["en-US"].dateTimeFormats,
  },
});

export default {
  name: "Localization",
  mounted() {
    this.$i18n.locale = this.settings.locale;
  },
  computed: {
    ...mapState(["settings"]),
    locale() {
      return locales[this.settings.locale].localeAntd;
    },
  },
  watch: {
    "settings.locale": function (value) {
      this.$i18n.locale = value;
    },
  },
};
</script>
